import { useCallback } from 'react'

import CruiseDepartureCabinPriceItem from 'components/Cruises/Common/Departures/CruiseDepartureCabinPriceItem'
import CruiseSimilarResultsLink from './CruiseSimilarResultsLink'
import type { CruiseDepartureCabinPrice } from 'lib/cruises/cruiseDeparturePricing'

interface Props {
  departure: App.CruiseDepartureDetails
  offer: App.CruiseOffer
  price: CruiseDepartureCabinPrice
}

function CruiseOfferPageDepartureCabinPriceItem({ departure, offer, price }: Props) {
  const renderSoldOutContent = useCallback((category: string) => <CruiseSimilarResultsLink
    cabinType={category}
    departure={departure}
    offer={offer}
  />, [departure, offer])

  return <CruiseDepartureCabinPriceItem
    offer={offer}
    price={price}
    hideIconOnDesktop
    renderSoldOutContent={renderSoldOutContent}
  />
}

export default CruiseOfferPageDepartureCabinPriceItem
